import { useSelector } from 'react-redux';
import { State } from '../core/reducers';
import { ChargebeePlans } from '@api/v1';

export function useIsFacilityManagerPlan() {
	const { account } = useSelector((state: State) => state.admin.account);

	return (
		account?.plan === ChargebeePlans.RELAY_JANITOR_FREE ||
		account?.plan === ChargebeePlans.RELAY_FACILITY_MANAGER
	);
}
